<footer class="footer">
    <div class="footer-container page-container">
        <div class="row footer-container-one">
            <div class="container-one-left col-xl-12 col-12 mb-3">
                <div class="left-wrapper mr-xl-5">
                    <img
                        [routerLink]="[RouterPath.HOME]"
                        src="assets/branding/logo-datacore.svg"
                        alt="DataCore"
                        style="width: 200px; cursor: pointer"
                    />
                    <div class="mt-3">
                        <div class="logo-container">
                            <a
                                href="https://www.facebook.com/profile.php?id=61579340397910"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src="assets/footer/facebook-icon.png"
                                    alt="DataCore on Facebook"
                                    width="16"
                                    height="16"
                                />
                            </a>

                            <a
                                href="https://www.linkedin.com/company/107784712/admin/feed/following"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src="assets/footer/linking-icon.png"
                                    alt="DataCore on LinkedIn"
                                    width="16"
                                    height="16"
                                />
                            </a>

                            <a
                                href="https://www.youtube.com/channel/UCMLpAhuq1X1NwUpK9zOLLfw"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src="assets/footer/youtube-icon.png"
                                    alt="DataCore on YouTube"
                                    width="16"
                                    height="16"
                                />
                            </a>

                            <a
                                href="https://github.com/organizations/DataCore-VietNam"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src="assets/footer/github-icon.png"
                                    alt="DataCore on Github"
                                    width="16"
                                    height="16"
                                />
                            </a>
                        </div>
                        <div class="subscribe-container">
                            <h2>{{ 'footer.subscribe.title' | translate }}</h2>
                            <p>
                                {{ 'footer.subscribe.description' | translate }}
                            </p>
                            <div class="subscribe-box">
                                <input type="email" placeholder="{{ 'footer.subscribe.placeholderEmail' | translate }}" [(ngModel)]="email"/>
                                <button type="button" (click)="subscribe()" [disabled]="subscribeStatus">{{ 'footer.subscribe.button' | translate }}</button>
                            </div>
                            <p class="require-text" *ngIf="!subscribeStatus">
                                {{ 'footer.subscribe.required' | translate }}
                            </p>
                            <p class="sucess-text" *ngIf="subscribeStatus">
                                {{ 'footer.subscribe.success' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-one-right col-xl-12 col-12 mb-3">
                <div class="row">
                    <div class="footer-column col-lg col-md-3 col-sm-6 col-12">
                        <div
                            class="column-header"
                            (click)="toggleFooterSection('about')"
                        >
                            <p class="column-title">
                                {{ 'footer.columns.about.title' | translate }}
                            </p>
                            <img
                                class="arrow"
                                src="assets/footer/arrow-down.png"
                                alt=""
                                width="16"
                                height="16"
                                [class.open]="footerSectionOpen.about"
                                />
                        </div>

                        <ul
                            class="no-bullet-list"
                            [class.show]="footerSectionOpen.about"
                        >
                            <li [routerLink]="[RouterPath.ABOUT]">
                                <a>{{ 'footer.columns.about.links.about' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.FAQS]">
                                <a>{{ 'footer.columns.about.links.faqs' | translate }}</a>
                            </li>
                            <li>
                                <a [href]="getBlogUrl()">{{ 'footer.columns.about.links.blog' | translate }}</a>
                            </li>
                            <li>
                                <a [href]="getNewsUrl()">{{ 'footer.columns.about.links.news' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.DOCS, RouterPath.USER_GUIDE]">
                                <a>{{ 'footer.columns.about.links.docs' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.DEMO, RouterPath.DATA_DOMAINS]">
                                <a>{{ 'footer.columns.about.links.demo' | translate }}</a>
                            </li>
                            <li>
                                <a [href]="getAILeaderboardUrl()">{{ 'footer.columns.about.links.aiLeaderboard' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-column col-lg col-md-3 col-sm-6 col-12">
                        <div
                            class="column-header"
                            (click)="toggleFooterSection('requests')"
                        >
                            <p class="column-title">{{ 'footer.columns.requests.title' | translate }}</p>
                            <img
                                class="arrow"
                                src="assets/footer/arrow-down.png"
                                alt=""
                                width="16"
                                height="16"
                                [class.open]="footerSectionOpen.requests"
                                />
                        </div>

                        <ul
                            class="no-bullet-list"
                            [class.show]="footerSectionOpen.requests"
                        >
                            <li [routerLink]="[RouterPath.VENDOR_FORM]">
                                <a>{{ 'footer.columns.requests.links.vendor' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.CUSTOM_DATA_REQUEST]">
                                <a>{{ 'footer.columns.requests.links.customData' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.DATACORE_PARTNER]">
                                <a>{{ 'footer.columns.requests.links.partner' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.DATACORE_PARTNERSHIP]">
                                <a>{{ 'footer.columns.requests.links.partnership' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.DATACORE_COR3]">
                                <a>{{ 'footer.columns.requests.links.cor3' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.DATACORE_SCHOLARS_FELLOWS]">
                                <a>{{ 'footer.columns.requests.links.scholarsFellows' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-column col-lg col-md-3 col-sm-6 col-12">
                        <div
                            class="column-header"
                            (click)="toggleFooterSection('policies')"
                        >
                            <p class="column-title">{{ 'footer.columns.policies.title' | translate }}</p>
                            <img
                                class="arrow"
                                src="assets/footer/arrow-down.png"
                                alt=""
                                width="16"
                                height="16"
                                [class.open]="footerSectionOpen.policies"
                                />
                        </div>

                        <ul
                            class="no-bullet-list"
                            [class.show]="footerSectionOpen.policies"
                        >
                            <li [routerLink]="[RouterPath.DOCS, RouterPath.POLICY]">
                                <a>{{ 'footer.columns.policies.links.privacy' | translate }}</a>
                            </li>
                            <li [routerLink]="[RouterPath.DOCS, RouterPath.TERMS]">
                                <a>{{ 'footer.columns.policies.links.terms' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-column col-lg col-md-3 col-sm-6 col-12">
                        <div
                            class="column-header"
                            (click)="toggleFooterSection('contributions')"
                        >
                            <p class="column-title">{{ 'footer.columns.contributions.title' | translate }}</p>
                            <img
                                class="arrow"
                                src="assets/footer/arrow-down.png"
                                alt=""
                                width="16"
                                height="16"
                                [class.open]="footerSectionOpen.contributions"
                                />
                        </div>

                        <ul
                            class="no-bullet-list"
                            [class.show]="footerSectionOpen.contributions"
                        >
                            <li [routerLink]="[RouterPath.FEEDBACK]">
                                <a>{{ 'footer.columns.contributions.links.feedback' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row footer-container-two">
            <div class="col-12 col-md-6">
                <img class="logo-bo-cong-thuong" src="assets/footer/logo-bo-cong-thuong.png" alt="Bộ Công Thương" width="130" height="44"/>
                <div class="footer-copyright">
                    {{ 'footer.copyright' | translate }}
                </div>
                <div class="footer-registration">
                    {{ 'footer.company.certificate' | translate }}
                    {{ 'footer.company.issuedOn' | translate }}
                    {{ 'footer.company.issuedBy' | translate }}
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="footer-company">
                    {{ 'footer.company.name' | translate }}<br/><br/>
                    {{ 'footer.company.address' | translate }}<br/>
                    {{ 'footer.company.content' | translate }}
                </div>
            </div>
        </div>
    </div>
</footer>
